export type View = 'home' | 'instant' | 'preparation' | 'rules' | 'takes' | 'timeline' | 'preflight' | 'receipt' | 'settings';
const views: View[] = ['home','instant','preparation','rules','takes','timeline','preflight','receipt','settings'];
export function readRoute() {
  const p = new URLSearchParams(location.search);
  return { view: views.includes(p.get('v') as View) ? p.get('v') as View : 'home' as View, programId: p.get('p') ?? p.get('program') ?? undefined };
}
export function pushRoute(view: View, programId?: string) {
  const url = new URL(location.href);
  url.searchParams.set('v', view);
  if (programId) url.searchParams.set('p', programId); else url.searchParams.delete('p');
  history.pushState({ view }, '', url);
}
